import { render, staticRenderFns } from "./PrintReceiptFrame.vue?vue&type=template&id=45068a4d&scoped=true"
import script from "./PrintReceiptFrame.vue?vue&type=script&lang=js"
export * from "./PrintReceiptFrame.vue?vue&type=script&lang=js"
import style0 from "./PrintReceiptFrame.vue?vue&type=style&index=0&id=45068a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45068a4d",
  null
  
)

export default component.exports